import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles.css';
import { boot } from './app/boot';
import { AppProviders } from './app/providers';
import { router } from './app/router';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

void boot().then(() => {
  createRoot(container).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
});
